import { createReducer, on } from '@ngrx/store';
import * as ScreeningCriteriaActions from './screening-criteria.actions';
import {ScreeningCriteriaDTO} from '../../dto/screening-criteria';

export interface ScreeningCriteriaState {
  criteriaByProject: { [projectId: number]: ScreeningCriteriaDTO[] };
  loadingByProject: { [projectId: number]: boolean };
  errorByProject: { [projectId: number]: any };
  selectedCriteria: ScreeningCriteriaDTO | null;
}

export const initialState: ScreeningCriteriaState = {
  criteriaByProject: {},
  loadingByProject: {},
  errorByProject: {},
  selectedCriteria: null,
};

export const screeningCriteriaReducer = createReducer(
  initialState,

  on(ScreeningCriteriaActions.loadScreeningCriterias, (state, { projectId }) => ({
    ...state,
    loadingByProject: {
      ...state.loadingByProject,
      [projectId]: true,
    },
    errorByProject: {
      ...state.errorByProject,
      [projectId]: null,
    },
  })),

  on(ScreeningCriteriaActions.loadScreeningCriteriasSuccess, (state, { projectId, criteria }) => ({
    ...state,
    criteriaByProject: {
      ...state.criteriaByProject,
      [projectId]: criteria,
    },
    loadingByProject: {
      ...state.loadingByProject,
      [projectId]: false,
    },
  })),

  on(ScreeningCriteriaActions.loadScreeningCriteriasFailure, (state, { projectId, error }) => ({
    ...state,
    loadingByProject: {
      ...state.loadingByProject,
      [projectId]: false,
    },
    errorByProject: {
      ...state.errorByProject,
      [projectId]: error,
    },
  })),

  on(ScreeningCriteriaActions.createScreeningCriteriaSuccess, (state, { projectId, criteria }) => ({
    ...state,
    criteriaByProject: {
      ...state.criteriaByProject,
      [projectId]: [...(state.criteriaByProject[projectId] || []), criteria],
    },
  })),

  on(ScreeningCriteriaActions.deleteScreeningCriteriaSuccess, (state, { projectId, id }) => ({
    ...state,
    criteriaByProject: {
      ...state.criteriaByProject,
      [projectId]: state.criteriaByProject[projectId]?.filter((c) => c.id !== id) || [],
    },
  })),

  on(ScreeningCriteriaActions.retrieveScreeningCriteriaSuccess, (state, { criteria }) => ({
    ...state,
    selectedCriteria: criteria,
  })),

  on(ScreeningCriteriaActions.updateScreeningCriteriaSuccess, (state, { projectId, criteria }) => ({
    ...state,
    criteriaByProject: {
      ...state.criteriaByProject,
      [projectId]: state.criteriaByProject[projectId]?.map((c) =>
        c.id === criteria.id ? criteria : c
      ) || [],
    },
  })),

  on(
    ScreeningCriteriaActions.createScreeningCriteriaFailure,
    ScreeningCriteriaActions.deleteScreeningCriteriaFailure,
    ScreeningCriteriaActions.retrieveScreeningCriteriaFailure,
    ScreeningCriteriaActions.updateScreeningCriteriaFailure,
    (state, { projectId, error }) => ({
      ...state,
      errorByProject: {
        ...state.errorByProject,
        [projectId]: error,
      },
    })
  )
);
